/* @flow weak */
import { getStyle } from 'lib/DOM';

function findScrollParent(node) {
  let tempNode = node;
  while (tempNode.parentNode) {
    tempNode = tempNode.parentNode;
    if (tempNode === document.body) {
      break;
    }
    const overflowY = getStyle(tempNode, 'overflow-y') || getStyle(tempNode, 'overflow');
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return tempNode;
    }
  }
  return window;
}

export default findScrollParent;



// WEBPACK FOOTER //
// ./src/utils/findScrollParent.js